import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const ToastError = (props) => (<Svg viewBox="0 0 20 20" fill="none" accessibilityRole="image" {...props}>
    <Path d="M8.575 3.217 1.516 15a1.667 1.667 0 0 0 1.425 2.5h14.117a1.666 1.666 0 0 0 1.425-2.5L11.425 3.217a1.667 1.667 0 0 0-2.85 0v0ZM10 7.5v3.333m0 3.334h.008" stroke="#fff" strokeWidth={1.667} strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default ToastError;
